import { useMemo } from 'react';

import TabControl from '../../../components/tabs/TabControl';
import { PathsLayouts } from '../../../config/routes';
import Discount from './Discount';
import Tariff from './Tariff';
import Tuition from './Tuition';

export default function TariffAndTuition() {
  const tabsPrefix = 'tariffAndTuition.tabs';
  const tabs = useMemo(
    () => [
      { name: 'tuitions', content: <Tuition /> },
      { name: 'tariff', content: <Tariff /> },
      { name: 'discounts', content: <Discount /> },
    ],
    [],
  );

  return (
    <>
      <TabControl
        tabsPrefix={tabsPrefix}
        tabs={tabs}
        path={PathsLayouts.tariffAndTuiton}
      />
    </>
  );
}
